<template>
  <el-dialog
    title="编辑别名"
    :visible.sync="dialog"
    width="700px"
    style="text-align: left"
    :close-on-click-modal="false"
    :before-close="close"
  >
    <div class="addbox">
      <div>
        <span>通用名：{{ nameData.generic_name }}</span>
      </div>
      <div style="margin: 15px 0 10px">
        <span style="margin-right: 10px">别名</span>
        <el-button
          type="primary"
          size="mini"
          icon="el-icon-plus"
          @click="addAlias"
        >新增</el-button>
      </div>
      <div style="border: solid 1px #c9cbd6">
        <el-table
          ref="multipleTable"
          :data="alias_data"
          tooltip-effect="dark"
          style="width: 100%"
          :header-cell-style="{ background: '#F5F5F5' }"
        >
          <el-table-column label="别名名称">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.alias_name"
                placeholder="10个字以内，不能重复"
                maxlength="10"
                @change="addAliasName(scope.row, scope.$index)"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="全拼">
            <template slot-scope="scope">
              <el-input v-model="scope.row.full_pname"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="简拼">
            <template slot-scope="scope">
              <el-input v-model="scope.row.simple_pname"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="60"
          >
            <template slot-scope="scope">
              <el-button
                icon="el-icon-delete"
                type="text"
                @click="delAliasName(scope.$index)"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div style="text-align: center; padding-bottom: 10px">
      <el-button
        @click="closeShow"
        style="width: 92px"
      >取 消</el-button>
      <el-button
        type="primary"
        @click="submit"
        style="width: 92px"
      >确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import _ from 'lodash';
export default {
  data() {
    return {
      alias_data: [
        {
          alias_name: '',
          full_pname: '',
          simple_pname: ''
        }
      ],
      generic_name: '',
      dialog: true
    };
  },
  props: ['nameData'],
  methods: {
    closeShow() {
      this.$emit('closeShow');
    },
    //获取别名列表
    getDrugTcmAliasInfo() {
      let drug_id = this.nameData.drug_id;
      this.axios
        .post('platform/template/getDrugTcmAliasInfo', { drug_id })
        .then((res) => {
          if (res.code == 0) {
            this.alias_data = res.data.list.map((item) => {
              item.alias_name = item.alias;
              return item;
            });
          }
        });
    },
    //提交
    submit() {
      let alias_data = this.alias_data.map((item) => {
        item = _.pick(item, ['alias_name', 'full_pname', 'simple_pname']);
        return item;
      });
      for (let i = 0; i < alias_data.length; i++) {
        if (
          !alias_data[i].alias_name ||
          !alias_data[i].full_pname ||
          !alias_data[i].simple_pname
        ) {
          this.$message.error('请填写完整再提交');
          return false;
        }
      }

      let data = {
        drug_id: this.nameData.drug_id,
        alias: alias_data
      };
      this.axios
        .post('platform/template/updateDrugTcmAlias', data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('提交成功');
            this.closeShow();
          }
        });
    },
    //新增别名
    addAlias() {
      //添加到第一个没有填写的格子
      let setIndex = this.alias_data.findIndex((ele) => {
        return !ele.alias_name && !ele.full_pname && !ele.simple_pname;
      });
      if (setIndex != -1 && this.alias_data.length) {
        return false;
      }
      let data = {
        alias_name: '',
        full_pname: '',
        simple_pname: ''
      };
      this.alias_data.push(data);
    },
    //别名名字
    addAliasName(row, index) {
      let obj = {
        alias_name: row.alias_name,
        full_pname: row.full_pname,
        simple_pname: row.simple_pname
      };
      this.alias_data.splice(index, 1, {
        alias_name: '',
        full_pname: '',
        simple_pname: ''
      });

      let alias_data = JSON.parse(JSON.stringify(this.alias_data));
      let aliasName = alias_data.find((ele) => {
        return ele.alias_name && ele.alias_name == row.alias_name;
      });

      if (aliasName && aliasName.alias_name) {
        console.log(aliasName);
        //重复不能添加
        this.$message({
          message: row.alias_name + '已经填写！',
          type: 'error'
        });
      } else {
        //添加到第一个没有填写的格子
        let setIndex = this.alias_data.findIndex((ele) => {
          return !ele.alias_name;
        });
        this.alias_data.splice(setIndex, 1, obj);
      }
    },
    //删除
    delAliasName(index) {
      this.alias_data.splice(index, 1);
    },
    close() {
      this.closeShow();
    }
  },
  created() {
    this.getDrugTcmAliasInfo();
  }
};
</script>
<style lang="scss" scoped>
.addbox {
  padding: 20px;
  box-sizing: border-box;
}
</style>
